export const lifeAtBitsclanArabicData = {
  banner: {
    heading: "حيث يجد الحالمون دافعهم والمبتكرون مسارهم",
    subHeading: "كن من صانعي التغيير",
    paragraphOne:
      "في Bitsclan، نؤمن بخلق بيئة يزدهر فيها الابتكار وتنمو فيها المسيرات المهنية. فريقنا هو مجموعة متنوعة من المحترفين الموهوبين، يجمعهم الشغف بالتكنولوجيا والالتزام بالتميّز. هنا، كل مشروع هو فرصة لتجاوز الحدود، وكل تحدٍّ هو طريق للنمو، وكل عضو في الفريق لديه القوة للقيادة.",
    paragraphTwo:
      "نقدّم لك الفرص لتطوير مهاراتك وتحقيق تأثير حقيقي. اكتشف كيف تبدو الحياة في Bitsclan، واتخذ الخطوة التالية في مسيرتك المهنية معنا.",
  },

  meetOurTeam: {
    heading: "نعمل بجد ونمرح أكثر",
    paragraphOne:
      "أخلاقيات عملنا مبنية على الالتزام والتعاون والتميّز لكننا نعرف أيضًا كيف نستمتع بوقتنا. سواء كانت مباريات مكثفة في ملعب تنس الطاولة الداخلي، أو منافسات ودية على PS5، أو عشاء جماعي، نحن نحرص دائمًا على تخصيص وقت للاسترخاء والمرح.",
    paragraphTwo:
      "ثقافتنا النابضة بالحياة لا تعزز فقط العمل الجاد، بل تزرع أيضًا روح الألفة والاسترخاء، مما يجعل Bitsclan مكانًا تنمو فيه مهنيًا وتستمتع بالرحلة.",
  },

  ceoIntro: {
    heading: "م. أويـس سـروار",
    subHeading:
      "لقد حسّنت مهاراتي الشخصية بشكل كبير من خلال حضوري لتدريبات عملية متنوعة. أصبحت أكثر ثقة وبنيت علاقات أقوى مع العملاء وزملائي في العمل.",
  },

  perksAndBenefit: {
    heading: "المزايا و",
    coloredHeading: "الفوائد",
    paragraph:
      "نؤمن أن موظفينا هم أعظم أصولنا، ونحن ملتزمون بتوفير بيئة عمل داعمة ومجزية. نقدم مجموعة من المزايا والفوائد المصممة لتعزيز رفاهيتك، والاعتراف بجهودك، والاحتفال بإنجازاتك. عند انضمامك إلى Bitsclan، فأنت لا تحصل فقط على وظيفة بل تنضم إلى مجتمع يقدّر مساهماتك ويدعم نموك.",
    benefits: [
      {
        title: "صندوق التقاعد",
        description:
          "أمّن مستقبلك مع خطة صندوق التقاعد الخاصة بنا، التي تساعدك على بناء أساس مالي قوي.",
        icon: "prek-iocn1.svg",
      },
      {
        title: "تأمين صحي",
        description:
          "صحتك ورفاهيتك من أولوياتنا. نقدم تأمينًا صحيًا شاملاً لتغطية احتياجاتك الطبية.",
        icon: "prek-iocn2.svg",
      },
      {
        title: "تحويل رصيد الإجازات",
        description:
          "احصل على مكافأة مقابل إجازاتك غير المستخدمة من خلال سياسة تحويل الإجازات إلى دخل إضافي.",
        icon: "prek-iocn3.svg",
      },
      {
        title: "إجازات مدفوعة",
        description:
          "خذ الوقت الذي تحتاجه مع سياسة الإجازات المدفوعة لدينا، سواء لأسباب شخصية أو للراحة التي تستحقها.",
        icon: "prek-iocn4.svg",
      },
      {
        title: "ساعات إضافية مدفوعة",
        description:
          "جهودك الإضافية لا تمر دون تقدير. نقدم تعويضًا ماليًا عن الساعات الإضافية التي تبذلها.",
        icon: "prek-iocn5.svg",
      },
      {
        title: "بدل هاتف محمول",
        description:
          "ابقَ على اتصال مع بدل الهاتف المحمول الذي نقدمه، لتكون لديك الأدوات اللازمة للتفوّق في عملك.",
        icon: "prek-iocn6.svg",
      },
      {
        title: "حفلات العشاء السنوية",
        description:
          "نحتفل بنجاحاتنا معًا من خلال حفلات العشاء السنوية، حيث نلتقي لنتبادل التقدير ونستمتع باللحظات.",
        icon: "prek-iocn7.svg",
      },
      {
        title: "أعياد الميلاد وذكرى الانضمام",
        description:
          "نؤمن بالاحتفال بك! من أعياد الميلاد إلى ذكرى انضمامك للعمل، نحرص على جعل هذه اللحظات مميزة وتُحتفل بها.",
        icon: "prek-iocn8.svg",
      },
    ],
    joinOurTeamButton: "انضم إلى فريقنا",
  },

  lifeGallery: {
    heading: "الحياة في Bitsclan",
    subHeading:
      "سواء كانت خدمات تطوير البرمجيات والاستشارات، أو خدمات اختبار الجودة، أو الأمن السيبراني، أو البلوكشين، أو العلامة التجارية الرقمية فنحن هنا لخدمتك! بغض النظر عن الخدمة التي تختارها، نحن نضمن الجودة العالية والنتائج الملموسة.",
  },
  partnersAndTeam: {
    heading: "كن شريكا",
    subHeading: "التعاون المتميز: بناء الجسور، ودفع النجاح",
    description:
      "تمكين الشراكات وتعزيز العمل الجماعي لتحقيق التميز الفائق. نهجنا المتفاني ورؤيتنا المشتركة تخلق تناغمًا يعزز الابتكار ويدفع النجاح المستدام للجميع.",
    btnHeading: "انضم إلى شبكة الشركاء",
    btnText: "كن شريكًا",
  },
};
